import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $libraryFavoritesTvShowsTranslations = combine(
  i18n.$t,
  ({ t }) => ({
    shows: t('series_favorite'),
  })
)
